import { ComparableMetric, ListedMetric, MetricRequest } from '@core/models/metric.models'
import { PlayerComparison } from '@core/models/player.models'
import { PlayerPosition } from '@core/enums/player.enums'
import { MetricDetailSubHeader } from '@features/metric-detail/models/metric-detail.models'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parsePlayerComparisonToMetricDetailRequest = (
  context: PlayerComparison,
  value: ListedMetric | ComparableMetric,
  playerPosition: PlayerPosition
): MetricRequest => ({
  teamId: context?.playerA?.teamId,
  seasonId: context?.playerA?.seasonId,
  competitionId: context?.playerA?.competitionId,
  playerId: context.playerA?.playerId,
  metricKey: value.key,
  playerPosition,
  comparePlayerId: context?.playerB?.playerId,
  compareTeamId: context?.playerB?.teamId
})

export const parsePlayerMatchComparisonToMetricDetailRequest = (
  context: PlayerComparison,
  value: ListedMetric | ComparableMetric,
  playerPosition: PlayerPosition
): MetricRequest => ({
  matchId: context?.playerA?.matchId,
  teamId: context?.playerA?.teamId,
  playerId: context.playerA?.playerId,
  metricKey: value.key,
  playerPosition,
  comparePlayerId: context?.playerB?.playerId,
  compareTeamId: context?.playerB?.teamId
})

export const parsePlayerComparisonMetricDetailSubHeader = (context: PlayerComparison): MetricDetailSubHeader => ({
  imageA: context?.playerA?.portraitLogo,
  textA: context.playerA?.metricPlayerName,
  imageAStyleClass: 'mcm-metric-detail__avatar',
  imageB: context?.playerB?.portraitLogo,
  textB: context.playerB?.metricPlayerName,
  imageBStyleClass: 'mcm-metric-detail__avatar',
  placeholderA: PLACEHOLDER_IMAGES.PLAYER,
  placeholderB: PLACEHOLDER_IMAGES.PLAYER
})
